import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter);

let routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: require('./pages/Home.vue')
  },
  {
    path: '/pharmacies',
    component: require('./pages/Pharmacies.vue')
  },
  {
    path: '/wholesalers',
    component: require('./pages/Wholesalers.vue')
  },
  {
    path: '/hospitals',
    component: require('./pages/Hospitals.vue')
  },
  {
    path: '/contact',
    component: require('./pages/Contact.vue')
  }
];

export default new VueRouter({
  routes
});



// WEBPACK FOOTER //
// ./src/router.js